import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Footer from '../../../../components/footer/';

class BottomFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { footer } = content;

        return (
            <div className={styles.bottomFooter}>
                <Footer content={footer} />
            </div>
        );
    }
}

export default errorBoundary(BottomFooter);
